// extracted by mini-css-extract-plugin
export var content = "u0GO0GnfkJLbg_ldI6E4";
export var info = "vhq_OejqWpX5vVEHErWu";
export var link = "CDBQNR5S0rSh1x_ZERxA";
export var negative = "f7L2shGgu6jIIOosVOrz";
export var neutral = "cGFVXBskxOI_50MijS_A";
export var positive = "vE1WRGFpN1eQ0UBPiiWt";
export var primary = "lSpmyzsGEWWFHpwMlyVQ";
export var root = "rNgeX0KziaPLMONbazHY";
export var secondary = "HZpi1cncfqoT0iCGNw8w";
export var sideItem = "eWsuPLRC3NLai2ai9AQ4";
export var warning = "IP7su8jXQY4lrlcuZEXl";